import React from "react";
import Container from "react-bootstrap/Container";
import Row from "react-bootstrap/Row";
import Col from "react-bootstrap/Col";
import "./about.css";

const About = () => {
  return (
    <div id="about">
      <div className="about">
        <h1 className="pt-3 text-center font-details pb-2">Nosotros</h1>
        <Container>
          <Row>
            <Col>
              <Row >
                <br />
                <p>¡Bienvenidos a Drepanocítico! Este proyecto ofrece educación virtual, asincrónica y gratuita para usuarios registrados.</p>
                <p>Drepanocítico es un recurso en línea dirigido a trabajadores del área de la salud que desean aprender o ampliar sus conocimientos sobre drepanocitosis.</p>
              </Row>
            </Col>
          </Row>
        </Container>
        <h3 className="pt-2 text-center font-details pb-2">Nuestra misión</h3>
        <Container>
          <Row>
            <Col>
              <Row >
                <br />
                <p>Aumentar los conocimientos sobre drepanocitosis entre los profesionales de la salud, con la finalidad de  mejorar la calidad de la atención médica recibida fuera de los centros especializados por los pacientes que la padecen.</p>
              </Row>
            </Col>
          </Row>
        </Container>
        <h5 className="pt-2 text-center font-details pb-2">Nuestra visión</h5>
        <Container>
          <Row>
            <Col>
              <Row >
                <br />
                <p>Que todos los niños con drepanocitosis tengan acceso a atención médica de alta calidad sin importar donde vivan o donde hayan nacido.</p>
              </Row>
            </Col>
          </Row>
        </Container>
        <h5 className="pt-2 text-center font-details pb-2">¿Por qué elegir Drepanocitico?</h5>
        <Container>
          <Row>
            <Col>
              <Row>
                <br />
                <ul className="about-list">
                  <li>
                    <strong>Información confiable y actualizada:</strong> Contenido elaborado por expertos en hematología de niños y adultos, ortopedia, nefrología, urología, cardiología, oftalmología, neurología y microbiología.
                  </li>
                  <li>
                    <strong>Acceso gratuito:</strong> Educación y recursos sin costo alguno.
                  </li>
                  <li>
                    <strong>Flexible y accesible:</strong> Aprendizaje en cualquier momento y desde cualquier lugar.
                  </li>
                </ul>
              </Row>
            </Col>
          </Row>
        </Container>
        <br /><br/>
      </div>
    </div>
  );
};

export default About;